import { render, staticRenderFns } from "./_Checkbox.vue?vue&type=template&id=233fafbe&scoped=true"
import script from "./_Checkbox.vue?vue&type=script&lang=js"
export * from "./_Checkbox.vue?vue&type=script&lang=js"
import style0 from "./_Checkbox.vue?vue&type=style&index=0&id=233fafbe&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233fafbe",
  null
  
)

export default component.exports